import calculation from '@/application/lib/calculations'

export default {
    computed: {
        totalCalculations(){
            return calculation.totals(this.conceptCalculation)
        },

        conceptCalculation() {
            const calcs = {}

            Object.keys(this.fields.concepts).forEach((key) => {
                const concept = this.fields.concepts[key];

                calcs[key] = calculation.concept({
                    price: concept.price,
                    quantity: concept.quantity,
                    discount: concept.discount,
                    iva: concept.iva,
                    surcharge: 0
                })
            })

            return calcs
        },
    }
}
